import { render, staticRenderFns } from "./search-modal-header.vue?vue&type=template&id=595478c9&scoped=true&"
import script from "./search-modal-header.vue?vue&type=script&lang=ts&"
export * from "./search-modal-header.vue?vue&type=script&lang=ts&"
import style0 from "./search-modal-header.vue?vue&type=style&index=0&id=595478c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595478c9",
  null
  
)

export default component.exports